var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 7L3.06435 9.16756C3.48321 9.60737 4.19421 9.5753 4.57177 9.09957L11 1","stroke":"#B4252D","stroke-width":"1.6","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }